import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  PawPrint, 
  Stethoscope, 
  Droplets, 
  Baby, 
  Wallet, 
  Package, 
  ClipboardList, 
  BarChart3, 
  Settings
} from 'lucide-react';

const navItems = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/animals', label: 'Hayvanlar', icon: PawPrint },
  { to: '/health', label: 'Sağlık', icon: Stethoscope },
  { to: '/milk', label: 'Süt Üretimi', icon: Droplets },
  { to: '/reproduction', label: 'Üreme', icon: Baby },
  { to: '/finance', label: 'Finans', icon: Wallet },
  { to: '/inventory', label: 'Envanter', icon: Package },
  { to: '/tasks', label: 'Görevler', icon: ClipboardList },
  { to: '/reports', label: 'Raporlar', icon: BarChart3 },
  { to: '/settings', label: 'Ayarlar', icon: Settings },
];

export default function Sidebar({ open, onClose }) {
  return (
    <>
      {open && (
        <div className="fixed inset-0 bg-black bg-opacity-30 z-20 lg:hidden" onClick={onClose} />
      )}

      <aside className={`
        fixed lg:static inset-0 z-30
        flex flex-col w-72 text-white
        transform transition-transform duration-300 ease-in-out
        ${open ? 'translate-x-0' : '-translate-x-full lg:translate-x-0 lg:w-16'}
      `}
      style={{ backgroundColor: 'rgb(22, 163, 74)' }}>
         <div className="flex items-center gap-3 px-4 py-5" style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>
          <img src="/mFk.png" alt="Logo" className="w-14 h-10 rounded-lg mfk-logo" style={{background:'transparent !important'}} />
          {open && <span className="font-bold text-lg">mFk Farm</span>}
        </div>

        <nav className="flex-1 py-4 overflow-y-auto">
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 mx-2 rounded-lg text-sm font-medium transition-all relative ${
                  isActive ? 'bg-green-800 text-white shadow-inner' : 'text-green-100 hover:bg-green-700 hover:text-white'
                }`
              }
              style={({ isActive }) => isActive ? {
                boxShadow: 'inset 4px 0 0 rgba(0, 0, 0, 0.3)'
              } : {}}
            >
              <item.icon className="w-5 h-5 flex-shrink-0" />
              {open && <span>{item.label}</span>}
            </NavLink>
          ))}
        </nav>

         {open && (
           <div className="px-4 py-3 text-xs text-green-200" style={{ borderTop: '1px solid rgba(255, 255, 255, 0.2)' }}>
             mFk Farm v1.0
           </div>
         )}
      </aside>
    </>
  );
}
